module.exports = __webpack_public_path__ + "img/tripwepay.c64dccf0.svg";